module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [(_vm.hmac && _vm.encrypted) ? _c('iframe', {
    attrs: {
      "src": _vm.urlOther,
      "id": "idFrame",
      "name": "nameFrame",
      "frameborder": "0",
      "width": "100%",
      "height": this.height,
      "allowfullscreen": "true"
    }
  }) : _c('center', [_c('b-spinner')], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-41a62ff1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41a62ff1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/axepta/PageAxepta.vue
// module id = 2397
// module chunks = 2